<ng-container
  *ngIf="{
    requisitionDetailsRequest: requisitionDetailsRequest$ | async,
    accountRequisition: accountRequisition$ | async,
  } as content"
>
  @if (!content.requisitionDetailsRequest?.isPristine) {
    @if (!content.requisitionDetailsRequest?.isLoading) {
      @if (!content.requisitionDetailsRequest?.hasError) {
        <div class="container-modal-request-details container-modal-account-details">
          <p>
            <span class="title">{{ 'approvalspage.modalAccountDetails.nameOfApplicant' | cxTranslate }}: </span>
            <span class="value"> {{ content.accountRequisition?.user }} </span>
          </p>

          <p>
            <span class="title">{{ 'approvalspage.modalAccountDetails.requestedAccount' | cxTranslate }}: </span>
            <span class="value"> {{ content.accountRequisition?.accountRequest?.account }} </span>
          </p>

          <p class="title m-t-12">{{ 'approvalspage.modalAccountDetails.reason' | cxTranslate }}</p>

          <div class="form-group m-0">
            <label class="m-0">
              <textarea
                class="form-control m-0"
                [maxLength]="255"
                rows="3"
                [placeholder]=""
                [value]="content.accountRequisition?.accountRequest?.reason"
                [disabled]="true"
              ></textarea>
            </label>
          </div>

          @if (content.accountRequisition?.code && content.accountRequisition?.status) {
            <modal-request-actions
              [code]="content.accountRequisition?.code!"
              [status]="content.accountRequisition?.status!"
              [approvalsDate]="content.accountRequisition?.approvalDate || undefined"
              [approvalsUser]="content.accountRequisition?.approvalUser || undefined"
              [replyConfig]="replyConfig"
              (_onReply)="reply($event)"
              (_onClose)="close()"
            ></modal-request-actions>
          }
        </div>
      } @else {
        <alert [alert]="alertMessage"></alert>
      }
    } @else {
      <local-loader></local-loader>
    }
  }
</ng-container>